<main>

  <nav  [ngClass]="getStyle()" class="navbar navbar-custom navbar-transparent navbar-fixed-top one-page" role="navigation">
    <div class="container">
      <div class="navbar-header">
        <button class="navbar-toggle" type="button" data-toggle="collapse" data-target="#custom-collapse">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <a class="navbar-brand upto" href="#totop">
          <img width="121" height="32" [src]="isCompany('logo/logo.png')" alt="Portfolio Item"/>
        </a>
      </div>
      <div class="collapse navbar-collapse" id="custom-collapse">
        <ul class="nav navbar-nav navbar-right">
          <li><a href="#totop" class="font-big"><b>{{txthv.menu_inicio}}</b> </a></li>
          <li><a class="section-scroll font-big" href="#offers"><b>Ofertas</b> </a></li>
          <li><a class="section-scroll font-big" href="#us"><b>{{txthv.menu_des_nos}}</b> </a></li>
          <li><a class="section-scroll font-big" href="#features"><b>{{txthv.menu_portal}}</b> </a></li>
          <li><a class="section-scroll font-big" *ngIf="txt.company == 'all' " target="_blank" [href]=txthv.urlempresa><b>Registra tu Empresa</b> </a></li>
          <!-- <li><a class="section-scroll font-big" *ngIf="txt.company != 'all' " target="_blank" [href]=txthv.urlempresa><b>Registra tu Empresa</b> </a></li> -->
          <!-- <li><a class="section-scroll" href="#pricing">Prices</a></li>
          <li><a class="section-scroll" href="#news">News</a></li>
          <li><a class="section-scroll" href="#contact">Contact</a></li> -->
        </ul>
      </div>
    </div>
  </nav>



  <section class="home-section bg-dark bg-gradient img-logo" [ngStyle]="{ 'background-image': getImage('banner.jpg') }" id="home">
          <div class="titan-caption">
            <div class="caption-content">
              <div class="font-alt mb-30 titan-title-size-1">{{txt.banner_main}}</div>
              <div class="font-alt mb-30 titan-title-size-3">{{txt.banner_sub}}</div>
              <div class="font-alt mb-40 titan-title-size-2">{{txt.banner_sub2}}</div>
              <!-- <a class="section-scroll btn btn-border-w btn-round" href="#">Learn More</a> -->
            </div>
          </div>

  </section>
  <section class="module-small bg-dark">
    <div class="container">
      <div class="row">
        <div class="col-sm-4 col-md-2 col-lg-2">
            <div class="callout-btn-box"><a target="_blank" href="https://play.google.com/store/apps/details?id=com.gongoplay.dreamjobs">
                <img src="assets/images/play-store.png" alt="Portfolio Item"/>
              </a></div>
        </div>
        <div class="col-sm-4 col-md-6 col-lg-8">
          <div class="callout-text font-alt text-center">
            <h3 class="callout-title mt-xs-20">¡Descarga DreamJobs App en tu móvil!</h3>
            <p>Carga tu hoja de vida siempre en el bolsillo y postúlate a todas las ofertas laborales desde cualquier lugar.</p>
          </div>
        </div>
        <div class="col-sm-4 col-md-2 col-lg-2">
          <div class="callout-btn-box"><a target="_blank" href="https://itunes.apple.com/us/app/dream-jobs/id962600699?l=es&ls=1&mt=8">
              <img src="assets/images/app-store.png" alt="Portfolio Item"/>
            </a></div>
        </div>
      </div>
    </div>
  </section>
        <section class="module" id="offers">
          <div class="container">
            <div class="row">
              <div class="col-sm-6 col-sm-offset-3">
                <h2 class="module-title font-alt">Nuestras Ofertas</h2>
              </div>
              <div class="col-sm-12">
<!--                 <h4 class="font-alt mb-0">Tabs</h4>
                <hr class="divider-w mt-10 mb-20"> -->
                <div role="tabpanel">
                  <ul class="nav nav-tabs font-alt" role="tablist">
                    <li *ngIf="txt.company == 'all' " class="active"><a class="color-dream" href="#all" data-toggle="tab">Empleos</a></li>
                    <li *ngIf="txt.company == 'all' " ><a href="#urgent" class="color-dream" data-toggle="tab">Urgentes</a></li>
                    <li *ngIf="txt.company == 'all' "><a href="#companies" class="color-dream" data-toggle="tab">Empresas</a></li>
                    <li *ngIf="txt.company != 'all' "><a href="#cities" class="color-dream" data-toggle="tab">Ciudades</a></li>
                  </ul>
                  <div class="tab-content">
                    <div class="tab-pane active" id="all" *ngIf="txt.company == 'all' ">
                            
                                <div class="input-group">
                                    <div class="input-group-addon"><i class="fa fa-search"></i></div>
                                    <input class="form-control input-lg" [(ngModel)]="searchAll" (keyup.enter)="searchFnAll()"  type="text" id="search" name="search" placeholder="Busca tu Oferta"/>
                                    <div class="input-group-addon color-dream-btn"><a target="_blank" (click)="searchFnAll()" class="btn btn-sm color-dream-btn" >Buscar</a></div>
                                  </div><br>

                            <div class="container">
                                <div class="col-sm-6 col-sm-offset-3">
                                    <h3 class='bolder font-alt fonttitle text-center'>Descargando DreamJobs en tú celular, tienes más ventajas, Pruébala ahora</h3><br>
                                </div>  
                            <div class="row text-center col-sm-offset-1" *ngIf="txt.name == 'El Espectador' ">
                                
                                  <div class="col-xs-12 col-md-5">
                                      <div class="row col-lg-offset-1" style="
                                      margin-top: 11px;
                                  ">
                                      <a href="https://user.dreamjobs.com.co/ofertas" target="_blank" >
                                        <img class="img-rounded" src="assets/images/cel_2.png" alt="Busca empleo desde la web con DreamJobs" />
                                      </a>
                                    </div><br>
                                    <div class="row col-lg-offset-1">
                                      <div class="col-xs-6 col-lg-6">
                                          <a href="https://play.google.com/store/apps/details?id=com.gongoplay.dreamjobs" target="_blank" >
                                            <img class="card-img-top img-rounded img-responsive center-block" src="assets/images/playstore.png" alt="Play Store" style="width: 145px; height: auto" />
                                          </a>
                                       </div>
                                       <div class="col-xs-6 col-lg-6">
                                          <a href="https://itunes.apple.com/us/app/dream-jobs/id962600699?l=es&ls=1&mt=8" target="_blank" >
                                            <img class="card-img-top img-rounded img-responsive center-block" src="assets/images/appstore.png" alt="App Store" style="width: 150px; height: auto"/>
                                          </a>
                                       </div> 
                        
                                    </div>                       
                                   </div>

                                <div class="col-xs-12 col-md-7 col-lg-7">
                                 
                                               <div class="row col-sm-offset-0">
                                             <div class="col-lg-9">
                               
                                                 <ul class="text-justify">
                                                      <li>
                                                  <h5>Carga tu hoja de vida en el bolsillo y postúlate a las ofertas laborales desde cualquier lugar.</h5>
                                                      </li>
                                                      <li>
                                                  <h5>Solicita retroalimentación pasadas 72 horas.</h5>
                                                      </li>
                                                      <li>
                                                  <h5>Sube tu video de presentación para tener más probabilidad de ser elegido a un cargo.</h5>
                                                      </li>
                                                      <li>
                                                  <h5>Sube una foto de perfil en tu hoja de vida.</h5>
                                                      </li>
                                                      <li>
                                                  <h5>Revisa las ofertas que nuestro algoritmo te recomienda según tu perfil.</h5>
                                                      </li>
                                                      <li>
                                                  <h5>Adjunta documentos que las empresas las empresas te solicitan.</h5>
                                                      </li>
                                                  </ul>
                                   
                                            </div>
                                           </div>			    
                                      </div>	                            
                             </div>
                            <div class="row col-sm-offset-1">

                                <div *ngFor="let jobAll of jobsAll"  class="col-sm-6 col-md-6 col-lg-6">
                                  <div class="alt-features-item">
                                      <div class="alt-features-icon"><span class="fa-icons icon-briefcase"></span></div>
                                       <a class="color-dream" target="_blank"  href="{{urlJob+jobAll.id}}"><h4 class="font-alt  ellipsis">{{jobAll.title}}</h4></a>

                                       <!-- <a class="color-dream" target="_blank"  href="" data-toggle="modal" data-target="#myModal4"><h4 class="font-alt  ellipsis">{{jobAll.title}}</h4></a> -->

                                        <div [ngClass]="{'widgetdj':true}">
                                           <ul [ngClass]="{'icon-list':true}">
                                            <li> <h5 class="ellipsis"><strong>Empresa:</strong> &nbsp; {{jobAll.company.name}}</h5></li>
                                            <li><h5 class="ellipsis"><strong>Area Laboral:</strong> &nbsp; {{jobAll.jc}}</h5> </li>
                                            <li><h5 class="ellipsis"><strong>Distancia:</strong> &nbsp; {{jobAll.venue.distance_formatted}}</h5> </li>
                                           </ul>
                                        </div>
                                  </div>
                                </div>
                              </div>
                              <div class="text-center">
                                  <ngb-pagination size="lg" class="d-flex justify-content-center" [collectionSize]="totalAll" [(page)]="pageAll" (pageChange)="getUpdateAll($event)" [maxSize]="6"  [pageSize]="6"></ngb-pagination>
                              </div>

                            </div>
                            <!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#myModal4">
                              Basic fadeIn effect
                          </button> -->
                          <!-- <div class="modal inmodal" id="myModal4" tabindex="-1" role="dialog"  aria-hidden="true">
                              <div class="modal-dialog">
                                  <div class="modal-content animated fadeIn">
                                      <div class="modal-header">
                                          <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
                                          <i class="fa fa-clock-o modal-icon"></i>
                                          <h4 class="modal-title">Modal title</h4>
                                          <small>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</small>
                                      </div>
                                      <div class="modal-body">
                                          <p><strong>Lorem Ipsum is simply dummy</strong> text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown
                                              printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,
                                              remaining essentially unchanged.</p>
                                      </div>
                                      <div class="modal-footer">
                                          <button type="button" class="btn btn-white" data-dismiss="modal">Close</button>
                                          <button type="button" class="btn btn-primary">Save changes</button>
                                      </div>
                                  </div>
                              </div>
                          </div> -->

                    </div>
                    <div class="tab-pane" id="urgent" *ngIf="txt.company == 'all' ">
                        <div class="input-group">
                            <div class="input-group-addon"><i class="fa fa-search"></i></div>
                            <input class="form-control input-lg" [(ngModel)]="searchUrgent" (keyup.enter)="searchFnUrgent()"  type="text" id="search" name="search" placeholder="Busca tu Oferta"/>
                            <div class="input-group-addon color-dream-btn"><a target="_blank" (click)="searchFnUrgent()" class="btn btn-sm color-dream-btn" >Buscar</a></div>
                          </div><br>


                        <div class="container">
                            <div class="col-sm-6 col-sm-offset-3">
                                <h3 class='bolder font-alt fonttitle text-center'>Descargando DreamJobs en tú celular, tienes más ventajas, Pruébala ahora</h3><br>
                            </div>  
                          <div class="row text-center col-sm-offset-1" *ngIf="txt.name == 'El Espectador' ">
                                <div class="col-xs-12 col-md-5">
                                    <div class="row col-lg-offset-1" style="
                                    margin-top: 11px;
                                ">
                                    <a href="https://user.dreamjobs.com.co/ofertas" target="_blank" >
                                      <img class="img-rounded" src="assets/images/cel_2.png" alt="Busca empleo desde la web con DreamJobs" />
                                    </a>
                                  </div><br>
                                  <div class="row col-lg-offset-1">
                                    <div class="col-xs-6 col-lg-6">
                                        <a href="https://play.google.com/store/apps/details?id=com.gongoplay.dreamjobs" target="_blank" >
                                          <img class="card-img-top img-rounded img-responsive center-block" src="assets/images/playstore.png" alt="Play Store" style="width: 145px; height: auto" />
                                        </a>
                                     </div>
                                     <div class="col-xs-6 col-lg-6">
                                        <a href="https://itunes.apple.com/us/app/dream-jobs/id962600699?l=es&ls=1&mt=8" target="_blank" >
                                          <img class="card-img-top img-rounded img-responsive center-block" src="assets/images/appstore.png" alt="App Store" style="width: 150px; height: auto"/>
                                        </a>
                                     </div> 
                      
                                  </div>                       
                                 </div>

                              <div class="col-xs-12 col-md-7 col-lg-7">
                               
                                             <div class="row col-sm-offset-0">
                                           <div class="col-lg-9">
                             
                                               <ul class="text-justify">
                                                    <li>
                                                <h5>Carga tu hoja de vida en el bolsillo y postúlate a las ofertas laborales desde cualquier lugar.</h5>
                                                    </li>
                                                    <li>
                                                <h5>Solicita retroalimentación pasadas 72 horas.</h5>
                                                    </li>
                                                    <li>
                                                <h5>Sube tu video de presentación para tener más probabilidad de ser elegido a un cargo.</h5>
                                                    </li>
                                                    <li>
                                                <h5>Sube una foto de perfil en tu hoja de vida.</h5>
                                                    </li>
                                                    <li>
                                                <h5>Revisa las ofertas que nuestro algoritmo te recomienda según tu perfil.</h5>
                                                    </li>
                                                    <li>
                                                <h5>Adjunta documentos que las empresas las empresas te solicitan.</h5>
                                                    </li>
                                                </ul>
                                 
                                          </div>
                                         </div>			    
                                    </div>	                            
                           </div>


                            
                              <div class="row col-sm-offset-1">

                                  <div *ngFor="let jobUrgent of jobsUrgent"  class="col-sm-6 col-md-6 col-lg-6">
                                  <div class="alt-features-item">
                                      <div class="alt-features-icon"><span class="fa-icons icon-briefcase"></span></div>
                                       <a class="color-dream" target="_blank" href="{{urlJob+jobUrgent.id}}"><h4 class="font-alt ellipsis">{{jobUrgent.title}}</h4></a>

                                        <div [ngClass]="{'widgetdj':true}">
                                           <ul [ngClass]="{'icon-list':true}">
                                            <li> <h5 class="ellipsis"><strong>Empresa:</strong> &nbsp; {{jobUrgent.company.name}}</h5></li>
                                            <li><h5 class="ellipsis"><strong>Area Laboral:</strong> &nbsp; {{jobUrgent.jc}}</h5> </li>
                                            <li><h5 class="ellipsis"><strong>Distancia:</strong> &nbsp; {{jobUrgent.venue.distance_formatted}}</h5> </li>
                                           </ul>
                                        </div>
                                  </div>
                                </div>
                              </div>
                              <div class="text-center">
                                  <ngb-pagination size="lg" class="d-flex justify-content-center" [collectionSize]="totalUrgent" [(page)]="pageUrgent" (pageChange)="getUpdateUrgent($event)" [maxSize]="6"  [pageSize]="6"></ngb-pagination>
                              </div>
                            </div>
                    </div>
                    <div *ngIf="txt.company != 'all' "  class="tab-pane active" id="cities">
                    <div class="container">
                        <div class="row col-sm-offset-1">
                          <div *ngFor="let jobCity of jobsCitySlice"  class="col-sm-6 col-md-6 col-lg-6">
                            <div class="alt-features-item">
                                 <a target="_blank" class="color-dream" href="https://user.dreamjobs.com.co/ofertas-ciudades/{{txt.company}}"><h4 class="font-alt  ellipsis">{{jobCity.city}}</h4></a>

                                  <div [ngClass]="{'widgetdj':true}">
                                     <ul [ngClass]="{'icon-list':true}">
                                      <li> <h5 class="ellipsis"><strong>Cantidad de Vacantes:</strong> &nbsp; {{jobCity.jobs.length}}</h5></li>
                                     </ul>
                                  </div>
                            </div>
                          </div>
                        </div>
                        <div class="text-center">
                            <ngb-pagination size="lg" class="d-flex justify-content-center" [collectionSize]="totalCity" (pageChange)="getUpdateCity($event)" [maxSize]="6"  [pageSize]="6"></ngb-pagination>
                        </div>

                      </div>

                    </div>

                    <div *ngIf="txt.company == 'all' "  class="tab-pane" id="companies">
                      <div class="input-group">
                          <div class="input-group-addon"><i class="fa fa-search"></i></div>
                          <input class="form-control input-lg" [(ngModel)]="searchCompany" (keyup.enter)="searchFnCompany()"  type="text" id="search" name="search" placeholder="Busca una Empresa"/>
                          <div class="input-group-addon color-dream-btn"><a target="_blank" (click)="searchFnCompany()" class="btn btn-sm color-dream-btn" >Buscar</a></div>
                        </div>

                      <div class="container">
                          <div class="row col-sm-offset-1">
                            <div *ngFor="let jobCompany of jobsCompanySlice"  class="col-sm-6 col-md-6 col-lg-6">
                              <div class="alt-features-item">
                                  <div class="alt-features-icon"><span><img [src]="jobCompany.logo" alt=""></span></div>
                                   <a target="_blank" class="color-dream" href="https://user.dreamjobs.com.co/ofertas"><h4 class="font-alt  ellipsis">{{jobCompany.company}}</h4></a>

                                    <div [ngClass]="{'widgetdj':true}">
                                       <ul [ngClass]="{'icon-list':true}">
                                        <li> <h5 class="ellipsis"><strong>Cantidad de Vacantes:</strong> &nbsp; {{jobCompany.jobs_count}}</h5></li>
                                       </ul>
                                    </div>
                              </div>
                            </div>
                          </div>
                          <div class="text-center">
                              <ngb-pagination size="lg" class="d-flex justify-content-center" [collectionSize]="totalCompany" (pageChange)="getUpdateCompany($event)" [maxSize]="6"  [pageSize]="6"></ngb-pagination>
                          </div>

                        </div>

                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="module" id="us">
          <div class="container">
            <div class="row">
              <div class="col-sm-6 col-sm-offset-3">
                <h2 class="module-title font-alt">Nuestra Empresa</h2>
                <div class="module-subtitle font-serif">{{txt.description}}</div>
              </div>
            </div>

          </div>
        </section>

  <div class="main">

    <section class="module bg-dark-60" data-background="assets/images/elespectador/banner.jpg">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <video #videoPlayer   [src] = "video_dir" class="video img-responsive video-box" preload="true" controls="false" muted>
            </video>
          </div>
        </div>
      </div>
    </section>
    <section class="module pb-0" id="features" >
      <div class="container">
        <div class="row">
          <div class="col-sm-6 col-sm-offset-3">
            <h2 class="module-title font-alt">{{txthv.titulo_features}}</h2>
            <div class="module-subtitle font-serif"></div>
          </div>
        </div>
      </div>

      <ul class="works-grid works-grid-gut works-grid-3 works-hover-w" id="works-grid">
<!--         <li class="work-item illustration webdesign"><a  target="_blank" href="https://company.dreamjobs.com.co/">
            <div class="work-image"><img src="assets/images/feat_1.png" alt="Portfolio Item"/></div>
            <div class="work-caption font-alt">
              <h3 class="work-title">Chatbots</h3>
              <div class="work-descr">A través de nuestros sofisticados Chatbots evalúa cientos de candidatos al tiempo evitando miles de horas de llamadas. <h5 class="color-dream"> Registrar Hoja de Vida </h5></div>
            </div></a></li>
        <li class="work-item marketing photography"><a  target="_blank" href="https://company.dreamjobs.com.co/">
            <div class="work-image"><img src="assets/images/feat_2.png" alt="Portfolio Item"/></div>
            <div class="work-caption font-alt">
              <h3 class="work-title">Tablero Inteligente</h3>
              <div class="work-descr">Visualiza mejor tu flujo de trabajo con nuestro Kanban Inteligente y crea nuevos estados según tus procesos y método de trabajo. <h5 class="color-dream"> Registrar Hoja de Vida </h5>
                </div>
            </div></a></li> -->
          <li class="work-item marketing webdesign">
            <div class="work-image"><img [src]=imgchatbots_dir alt="Portfolio Item"/></div>
            <div class="work-caption font-alt">
              <!-- <h3 class="work-title">Informes Automatizados</h3> -->
              <div class="work-descr"><h3>{{txthv.titulo_chatbots}}</h3> {{txthv.chatbots}}
                <a target="_blank" [href]=txthv.urlempresa><h5 class="color-dream"> {{txthv.titulo_urlempresa}} </h5></a>
            </div>
          </div></li>
          <li class="work-item marketing webdesign">
            <div class="work-image"><img [src]=imgkanban_dir alt="Portfolio Item"/></div>
            <div class="work-caption font-alt"><h3>{{txthv.titulo_kanban}}</h3> {{txthv.kanban}}
              <!-- <h3 class="work-title">Requisitos Obligatorios</h3> -->
              <div class="work-descr">
                <a target="_blank" [href]=txthv.urlempresa><h5 class="color-dream"> {{txthv.titulo_urlempresa}} </h5></a>
            </div>
          </div></li>
          <li class="work-item illustration photography">
            <div class="work-image"><img [src]=imgbd_dir alt="Portfolio Item"/></div>
            <div class="work-caption font-alt"><h3>{{txthv.titulo_BD}}</h3> {{txthv.BD}}
              <!-- <h3 class="work-title">Base de Datos</h3> -->
              <div class="work-descr">
                <a target="_blank" [href]=txthv.urlempresa><h5 class="color-dream"> {{txthv.titulo_urlempresa}} </h5></a>
              </div>
            </div></li>
        <li class="work-item marketing webdesign">
            <div class="work-image"><img [src]=imgfc_dir alt="Portfolio Item"/></div>
            <div class="work-caption font-alt"><h3>{{txthv.titulo_FC}}</h3> {{txthv.FC}}
              <!-- <h3 class="work-title">Formulario por Competencias</h3> -->
              <div class="work-descr">
                <a target="_blank" [href]=txthv.urlempresa><h5 class="color-dream"> {{txthv.titulo_urlempresa}} </h5></a>
            </div>
          </div></li>
        <li class="work-item illustration webdesign">
            <div class="work-image"><img [src]=imggd_dir alt="Portfolio Item"/></div>
            <div class="work-caption font-alt"><h3>{{txthv.titulo_GD}}</h3> {{txthv.GD}}
              <!-- <h3 class="work-title">Gestor Documental</h3> -->
              <div class="work-descr">
                <a target="_blank" [href]=txthv.urlempresa><h5 class="color-dream"> {{txthv.titulo_urlempresa}} </h5></a>
              </div>
            </div></li>
        <li class="work-item marketing photography">
            <div class="work-image"><img [src]=imgpc_dir alt="Portfolio Item"/></div>
            <div class="work-caption font-alt"><h3>{{txthv.titulo_PC}}</h3> {{txthv.PC}}
              <!-- <h3 class="work-title">Post Contratación</h3> -->
              <div class="work-descr">
                <a target="_blank" [href]=txthv.urlempresa><h5 class="color-dream"> {{txthv.titulo_urlempresa}} </h5></a>
              </div>
            </div></li>
      </ul>
    </section>

    <hr class="divider-w">

    <div [ngClass]="getStyle()" class="module-small-footer bg-dark">
      <div class="container">
        <div class="row">
            <div  class="col1">
              <div class="col-md-12 text-center">

                <img height="150" width="75" src="assets/images/dreamjobs-logo.png" alt="">
                <img src="assets/images/empleo.png" alt="">

              </div>
              <div class="col-md-10 col-md-offset-1">

                 <div class="font-alt little copyright text-center">Vinculado a la red de prestadores del Servicio Público de Empleo. Autorizado por la Unidad Administrativa Especial del Servicio Público de Empleo según resolución No. 000330 de 2018.</div>

              </div>
              <div class="col-sm-4 text-center col-md-offset-4">
                    <i class="fa fa-balance-scale"></i><a class="link" href="#totop" onclick="window.open('assets/descarga/reglamento.pdf')">Términos y Condiciones</a>
          </div>
            </div>
        </div>
      </div>
    </div>
    <!-- <hr class="divider-d"> -->
    <!--  FOOTERS -->
    <footer [ngClass]="getStyle()" class="footer bg-dark" >
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <p class="copyright  font-alt">&copy; 2018&nbsp;<a class="link" href="index.html">Dreamjosb</a>, el trabajo de tus sueños</p>
          </div>
          <div class="col-sm-6">
            <!-- <div class="footer-social-links"><a href="#"><i class="fa fa-facebook"></i></a><a href="#"><i class="fa fa-twitter"></i></a><a href="#"><i class="fa fa-dribbble"></i></a><a href="#"><i class="fa fa-skype"></i></a>
            </div> -->
          </div>
        </div>
      </div>
    </footer>
  </div>
  <div class="scroll-up"><a href="#totop"><i class="fa fa-angle-double-up"></i></a></div>

</main>



// WEBPACK FOOTER //
// ./src/app/landing/landing.component.html